module.exports = __webpack_public_path__ + "static/media/secure.017dca1e.svg";